import styled from "styled-components/macro";

export const InputMessageSection = styled.div`
  display: flex;
  align-items: center;
  background: #ffffff;
  border-radius: 8px;
  padding-right: 8px;
  & button {
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: center;
  }
`;

export const InputMessage = styled.textarea`
  width: 100%;
  height: 56px;
  border: none;
  border-radius: 8px;
  font-size: 18px;
  line-height: 26px;
  padding: 13.5px 16px;
  resize: none;
`;
